<template>
    <rkm-form
        ref="RkmForm"
        v-if="form"
    >
        <rkm-area type="fieldset" title="Identificação">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        uppercase
                        label="Nome"
                        v-model="model.cidadao.nome"
                        :validations="validations.cidadao.nome"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Sexo"
                        v-model="model.cidadao.sexoId"
                        :validations="validations.cidadao.sexo"
                        value-field="id"
                        text-field="descricao"
                        :options="form.sexos"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area type="fieldset" title="Conselho profissional">
            <rkm-row>
                <rkm-col :cols="tipoRegistroOutro ? '2' : '6'">
                    <rkm-form-select
                        :options="form.documentos.conselhoProfissional.tiposRegistro"
                        label="Tipo"
                        text-field="descricao"
                        v-model="model.documentos.conselhoProfissional.registroTipoId"
                        :validations="validations.registroTipoId"
                        value-field="id"
                        show-default-option
                        @change="handleRegistroTipoChange()"
                    />
                </rkm-col>

                <rkm-col
                    v-if="tipoRegistroOutro"
                    cols="4"
                >
                    <rkm-form-input
                        :validations="validations.registroTipoOutro"
                        label="Outro"
                        v-model="model.documentos.conselhoProfissional.registroTipoOutro"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.registroNumero"
                        label="Número"
                        v-model="model.documentos.conselhoProfissional.registroNumero"
                        :disabled="!model.documentos.conselhoProfissional.registroTipoId"
                        @blur="handleNumeroBlur()"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        :options="form.documentos.conselhoProfissional.estados"
                        label="UF"
                        text-field="uf"
                        v-model="model.documentos.conselhoProfissional.registroEstadoId"
                        :disabled="!model.documentos.conselhoProfissional.registroNumero"
                        value-field="id"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>

//Mixins
import {repository, error, object, stringCase} from '@/mixins'

//Vuex
import {mapActions} from 'vuex'

// Enums.
import tipoRegistro from '@/enums/cadastro/usuario/tipoRegistro'

export default {
    computed: {
        validations() {

            return {
                cidadao: {
                    nome: {
                        required: true,
                        min: 6,
                        max: 150,
                        name: true,
                    },
                    sexo: {
                        required: true
                    },
                },
                registroTipoId: { required: true },
                registroNumero: { required: true, max: 25 },
                registroEstado: { required: !!this.model.documentos.conselhoProfissional.registroNumero },
                registroTipoOutro: { required: this.tipoRegistroOutro, max: 50 }
            }
        },
        tipoRegistroOutro() {

            return this.model.documentos.conselhoProfissional.registroTipoId === this.enums.tipoRegistro.OUTRO
        }
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }

        this.load()
    },
    data: () => ({
        enums: { tipoRegistro },
        model: {
            cidadao: {
                cadastroSimplificado: true,
                semDocumentos: true,
                cpfNaoPertenceAoCidadao: false,
                nome: null,
                cpf: null,
                dataNascimento: null,
                desconheceNomeMae: true,
                desconheceNomePai: true,
                domicilio: null,
                estadoNascimentoId: null,
                municipioNascimentoId: null,
                nacionalidadeId: null,
                racaCorId: null,
                sexoId: null,
                telefones: [],
                paisNascimentoId: null
            },
            documentos: {
                conselhoProfissional: {
                    registroTipoId: null,
                    registroTipoOutro: '',
                    registroNumero: '',
                    registroEstadoId: null,
                }
            },
        },
        form: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.usuario.create()
                .then(({data}) => {

                    this.form = this.clone(data.form)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.usuario.store(this.camelObjectKeysToSnakeRecursive(this.model))
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', this.clone(data))
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        handleNumeroBlur() {

            const registroNumero = this.model.documentos.conselhoProfissional.registroNumero

            if (!registroNumero) {

                this.model.documentos.conselhoProfissional.registroEstadoId = null
            }
        },
        handleRegistroTipoChange() {

            if (!this.model.documentos.conselhoProfissional.registroTipoId) {

                this.model.documentos.conselhoProfissional.registroNumero = null
                this.model.documentos.conselhoProfissional.registroEstadoId = null
            }

            this.model.documentos.conselhoProfissional.registroTipoOutro = null
        }
    },
    mixins: [repository, error, object, stringCase]
}
</script>